// @flow
/* eslint-disable no-underscore-dangle */
import moment from 'moment'
import supportedLangModules from './supportedLangModules.macro'
import importWithRetry from 'mz-utils/importWithRetry'

const momentLocaleModules = supportedLangModules({
  modulePrefix: 'moment/locale',
  localeField: 'moment',
  chunkPrefix: 'moment-locale',
})

/**
 * Load the moment locale if it is not loaded yet and add to to intl
 * when loaded. It does nothing if locale is enslish or already presented
 * in intl utils.
 * @param  {string} localeName
 * @return {Promise}
 */
function loadIntlMoment(localeName: string): Promise<void> {
  if (!momentLocaleModules[localeName]) {
    moment.locale('en')
    return Promise.resolve()
  }

  // It is not good, but there is no other way to do the same with locales
  // located in the moment package. These locales are trying to access global
  // moment if no CJS/AMD env defined
  if (typeof window !== 'undefined') {
    window.moment = moment
  }

  return importWithRetry(momentLocaleModules[localeName]).then((momentLocale) =>
    moment.locale(momentLocale)
  )
}

export default loadIntlMoment
